import { motion } from "framer-motion";

import manufactureImg from "./assets/manufacture.png";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#FFFAED] py-28 px-6 md:px-10">
      <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        {/* Left Column – 60% with animation */}
        <motion.div
          className="w-full lg:w-[60%]"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h5 className="text-[#212129] text-xs font-medium uppercase mb-3 tracking-wide">
            Manufacturing
          </h5>

          <h2 className="text-[#1E1E1E] text-[40px] md:text-[40px] font-extrabold leading-tight mb-4">
            Making products using <br />
            machines and labor.
          </h2>

          <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
            Manufacturing is the process of converting raw materials into
            finished <br /> goods using machinery, tools and labor.
          </p>
        </motion.div>

        {/* Right Column – 40% with animation */}
        <motion.div
          className="w-full lg:w-[40%] flex justify-center -mt-2"
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          <img
            src={manufactureImg}
            alt="Manufacture Illustration"
            className="w-[380px] sm:w-[460px] md:w-[520px] w-full max-w-[600px] h-auto object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
